import { useClientPortalAPI } from "@certn/api";
import { useMemo } from "react";

import { LOCKED_AUSTRALIAN_ORDERING } from "./types";
import { indexUsCriminalCatalogPrices } from "./utils";

export function useAustralianOrderingFlags(enabled = false) {
  const { data } = useClientPortalAPI(
    enabled
      ? "/api/internal/client-portal/check-arguments-templates/criminal-record/australian-ordering/"
      : null
  );

  return data ?? LOCKED_AUSTRALIAN_ORDERING;
}

export function useUsCriminalCatalogPrices(enabled = false) {
  const { data } = useClientPortalAPI(
    enabled
      ? "/api/internal/client-portal/customer-accounts/available-checks/"
      : null
  );

  return useMemo(() => indexUsCriminalCatalogPrices(data), [data]);
}

export function useCriminalRecordTemplatesInPackages() {
  const { data: packages } = useClientPortalAPI(
    "/api/internal/client-portal/packages/"
  );

  if (!packages) {
    return [];
  }

  const templateIds = new Set<string>();

  packages.results?.forEach((pkg) => {
    pkg.packagecheck_set?.forEach((check) => {
      const checkArgs = check.arguments as Record<string, unknown>;
      if (checkArgs?.template_id) {
        templateIds.add(checkArgs.template_id as string);
      }
    });
  });

  return Array.from(templateIds);
}
